import React, { useState } from 'react'
import { Button } from '../../../components/ui/button';
import DeleteAccountModal from './DeleteAccountModal'

const DeleteAccount: React.FC = () => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  
  return (
    <>
      <div className="px-4 pb-3 pt-2 sm:px-6">
        <div className="rounded-lg bg-[#FE724C26] p-4">
          <h2 className="text-md mb-1 font-medium text-primary">
            Delete Your Account
          </h2>
          <p className="mb-3 text-sm text-gray-500">
            By deleting your account, you'll lose all rewards
            and won't be able to make payments or log in to the
            User Portal.
          </p>
          <Button
            type="button"
            onClick={() => setShowDeleteConfirmation(true)}>
            Delete Account
          </Button>
        </div>
      </div>

      {showDeleteConfirmation && (
        <DeleteAccountModal onClose={() => setShowDeleteConfirmation(false)} />
      )}
    </>
  )
}

export default DeleteAccount;